import { SignInForm } from '@/components/auth/sign-in-form'
import { Link } from 'react-router-dom'

export default function SignInPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
        <div className="flex-1 flex flex-col justify-center px-4 sm:px-6 lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            {/* Header */}
            <div className="mb-8 text-center">
              <h1 className="text-3xl font-bold tracking-tight mb-2">
                Welcome Back
              </h1>
              <p className="text-muted-foreground">
                Sign in to access live worship and community
              </p>
            </div>

            {/* Form */}
            <SignInForm showHeader={false} showFooter={false} />

            {/* Footer Links */}
            <div className="mt-8 text-center text-sm">
              <p className="text-muted-foreground">
                Don't have an account?{' '}
                <Link to="/auth/signup" className="font-medium text-primary hover:underline">
                  Sign up
                </Link>
              </p>
              <p className="mt-4 text-muted-foreground">
                New here?{' '}
                <Link to="/auth/signup" className="font-medium text-primary hover:underline">
                  Create an account
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
  )
}
